export enum ConfigurationTypeEnum {
  flytAPIKey = 'Flyt API Key',
  flytLocationRefID = 'Flyt Location Ref ID',
  flytVendorName = 'Flyt Vendor Name',
  flytCollectionMenu = 'Flyt Collection Menu - Sync',
  flytDeliveryMenu = 'Flyt Delivery Menu - Sync',
  flytUpcoAPIKey = 'Flyt UpCo API Key',
  deliverooBrandName = 'Deliveroo Brand Name',
  deliverooMenuName = 'Deliveroo Menu Name',
  deliverooAPIKey = 'Deliveroo API Key',
  deliverooAPIToken = 'Deliveroo API Token',
  deliverooLocationRefID = 'Deliveroo Location Ref ID',
  uberEatsClientId = 'Uber Eats Client Id',
  uberEatsClientSecret = 'Uber Eats Client Secret',
  uberEatsStoreId = 'Uber Eats Store Id',
  uberEatsMenuName = 'Uber Eats Menu Name',
  posQuickPayPaymentMethod = 'POS Quick Pay Payment Method',
  posProductSearch = 'POS Product Search',
  posSendAndPay = 'POS Send And Pay',
  synergyCorporateId = 'Synergy Corporate Id',
  synergyOutletId = 'Synergy Outlet Id',
}
